import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { LegalHoliday, LegalHolidayRequest } from './LegalHolidayTypes';

export const legalHolidaySchema = z.object({
  date: z.string().min(1),
  name: z.string().trim().min(1),
});

export type LegalHolidaySchema = z.infer<typeof legalHolidaySchema>;

export const defaultLegalHolidayValues: DefaultValues<LegalHolidaySchema> = {
  name: '',
};

export function toLegalHolidaySchema(legalHoliday: LegalHoliday): LegalHolidaySchema {
  return {
    date: legalHoliday.date,
    name: legalHoliday.name,
  };
}

export function toLegalHolidayRequest(values: LegalHolidaySchema): LegalHolidayRequest {
  return {
    date: values.date,
    name: values.name,
  };
}
